var React = require('react');

function TwitterInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19 8.3a5.828 5.828 0 01-1.646.436c.6-.347 1.05-.893 1.266-1.537a5.886 5.886 0 01-1.823.674 2.908 2.908 0 00-1.63-.837 2.96 2.96 0 00-1.82.293c-.556.288-1 .746-1.26 1.302a2.698 2.698 0 00-.185 1.775 8.367 8.367 0 01-3.281-.841 8.106 8.106 0 01-2.643-2.061 2.703 2.703 0 00-.315 2.023c.165.689.595 1.291 1.202 1.684a2.954 2.954 0 01-1.302-.346v.034c0 .642.23 1.263.65 1.76.42.496 1.004.837 1.655.964a2.985 2.985 0 01-1.3.047 2.793 2.793 0 001.023 1.38 2.945 2.945 0 001.662.548A5.92 5.92 0 015 16.752 8.323 8.323 0 009.404 18c5.282 0 8.172-4.234 8.172-7.905 0-.122 0-.24-.009-.359A5.69 5.69 0 0019 8.3z","fill":"#000"}));
}

TwitterInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = TwitterInline;

TwitterInline.default = TwitterInline;
